const NAMESPACE = "pcFile";

const KEYS = {
    allowedFileTypes: "allowedFileTypes",
    cancelButton: "cancelButton",
    viewButton: "viewButton",
    removeButton: "removeButton",
    removeDialogTitle: "removeDialogTitle",
    removeDialogMessageDefault: "removeDialogMessageDefault",
    cancelRemoveButton: "cancelRemoveButton",
    approveRemoveButton: "approveRemoveButton",
    uploadingMessageText: "uploadingMessageText",
    couldNotUploadMessage: "couldNotUploadMessage",
    fileNotFoundMessage: "fileNotFoundMessage",
    singleExtensionInvalidMessageText: "singleExtensionInvalidMessageText",
    multipleExtensionInvalidMessage: "multipleExtensionInvalidMessage",
    fileTooLargeMessageText: "fileTooLargeMessageText",
    chooseFileAltLabel: "chooseFileAltLabel",
    fileNameExccedsLimitText: "fileNameExccedsLimitText",
    browseButtonLabel: "browseButtonLabel"
};

const MESSAGES = {
    [KEYS.allowedFileTypes]: {
        value: "Allowed file types: ",
        comment: "Label for list of allowed file extension types"
    },
    [KEYS.cancelButton]: {
        value: "Cancel",
        comment: "Label for button which cancels an in-progress upload"
    },
    [KEYS.viewButton]: {
        value: "View",
        comment: "Label for button which allows the user to view the file"
    },
    [KEYS.removeButton]: {
        value: "Remove",
        comment: "Label for button which allows the user to remove a previously uploaded file"
    },
    [KEYS.removeDialogTitle]: {
        value: "Confirm remove",
        comment: "Header for dialog when a file is about to be removed"
    },
    [KEYS.removeDialogMessageDefault]: {
        value: "Are you sure you want to remove this file?",
        comment: "Default message in dialog box when user attempts to remove a file"
    },
    [KEYS.cancelRemoveButton]: {
        value: "Cancel",
        comment: "Button which cancels a file removal operation"
    },
    [KEYS.approveRemoveButton]: {
        value: "OK",
        comment: "Button which lets the user proceed with removing a file"
    },
    [KEYS.uploadingMessageText]: {
        value: "Uploading {filename}",
        comment: "Message to display when the file has been changed"
    },
    [KEYS.couldNotUploadMessage]: {
        value: "Could not upload file.",
        comment: "Default error message"
    },
    [KEYS.fileNotFoundMessage]: {
        value: "Selected file was not found.",
        comment: "Error message for when file was not found."
    },
    [KEYS.singleExtensionInvalidMessageText]: {
        value: "Must have a .{extension} extension.",
        comment: "Error message for improper file extension when only one extension is allowed."
    },
    [KEYS.multipleExtensionInvalidMessage]: {
        value: "Must have one of the following extensions:",
        comment: "Error message for improper file extension when multiple extensions are allowed."
    },
    [KEYS.fileTooLargeMessageText]: {
        value: "File size exceeds the {sizeMb} MB limit.",
        comment: "Error message for when uploaded file is too large."
    },
    [KEYS.chooseFileAltLabel]: {
        value: "Choose file",
        comment: "Alt label shown to screen readers if no placeholder is given"
    },
    [KEYS.fileNameExccedsLimitText]: {
        value: "File name must be less than 128 characters.",
        comment: "Error message when filename exceeds 128 characters"
    },
    [KEYS.browseButtonLabel]: {
        value: "Browse",
        comment: "Browse label for file upload button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
